import { render, staticRenderFns } from "./ChatHeader.vue?vue&type=template&id=166d2ac1&scoped=true&"
import script from "./ChatHeader.vue?vue&type=script&lang=js&"
export * from "./ChatHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChatHeader.vue?vue&type=style&index=0&id=166d2ac1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166d2ac1",
  null
  
)

export default component.exports